export default () => {
  const tabs = document.querySelectorAll('.js-tab')

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tab.classList.toggle('tab-unit--active')
      const data = tab.getAttribute('data-box')
      document.querySelector(`.tab-box--${data}`).classList.toggle('tab-box--active')
    })
  })
}